/*

Array of object

Top level object can be:
1. Header
2. Group (Group can have navItems as children)
3. navItem

* Supported Options

/--- Header ---/

header

/--- nav Grp ---/

title
icon (if it's on top level)
tag
tagVariant
children

/--- nav Item ---/

icon (if it's on top level)
title
route: [route_obj/route_name] (I have to resolve name somehow from the route obj)
tag
tagVariant

*/
import dashboard from './dashboard'
import users from './users'
import others from './others'
import order from './order'
import ticket from './ticket'
import banner from './banner'
import slideshow from './slideshow'
import honor from './honor'
import notification from './notification'
import checkErrors from './checkErrors'
import lead from './lead'
import ai from './ai'
import report from './report'

// import others from './others'

import blog from './blog'
import project from './project'
import product from './product'

// Array of sections
export default [...dashboard, ...report, ...users, ...product, ...blog, ...project, ...order, ...banner,...slideshow, ...others, ...ticket, ...lead, ...ai, ...honor, ...notification, ...checkErrors]
